import React from 'react';
import Button from './Button';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-12 sm:py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto sm:mx-0">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-center sm:text-left">
            Excelência em<br className="hidden sm:block" />Gestão da Qualidade
          </h1>
          <p className="text-lg sm:text-xl mb-6 sm:mb-8 text-center sm:text-left">
            Transforme seus processos com soluções sob medida, garantindo conformidade, eficiência e alinhadas às normas ISO.
          </p>
          <div className="text-center sm:text-left">
            <Link to="/contato">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/20">
                Entre em contato
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;